import React from 'react';
import PlayerStatistics from '../components/PlayerStatistics';

export default function MyStatisticsTab({ userId }) {
  return <PlayerStatistics userId={userId} />;
}
